import { ProfileDataSource } from './profile.datasource';
import { inject, Injectable } from '@angular/core';
import {
  collection,
  CollectionReference,
  Firestore,
  docData,
  doc,
  setDoc,
  updateDoc,
} from '@angular/fire/firestore';
import { Profile } from '@domain/aggregates';
import { RegistrationState } from '../../auth/registration-state';
import { map } from 'rxjs';
import { convertTimestamps } from '../../utils/firebase-converters';

export class FirebaseProfileDatasource extends ProfileDataSource {
  readonly #firestore = inject(Firestore);
  readonly #collection = collection(
    this.#firestore,
    'profiles'
  ) as CollectionReference<Profile>;

  createUserProfile(uid: string, profile: Profile) {
    const ref = doc(this.#firestore, 'profiles', uid);
    return setDoc(ref, profile, { merge: true });
  }

  getProfileByUserId(uid: string) {
    return docData(doc(this.#collection, uid)).pipe(
      map((data: any) => (data ? convertTimestamps(data) : undefined))
    );
  }

  patchProfile(uid: string, data: Partial<Profile>) {
    const ref = doc(this.#firestore, 'profiles', uid);
    return updateDoc(ref, { ...data, updatedAt: new Date() });
  }
}
